import { EpimsGenderDto } from '@cradua/data';
import { environment } from 'apps/epims/mrsoftepims/src/environments/environment';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GenderService {
  url = environment.apiUrl;
  constructor(private http: HttpClient) {}

  getGender(): Observable<EpimsGenderDto[]> {
    return this.http.get<EpimsGenderDto[]>(this.url + 'gender');
  }

  createGender(data: EpimsGenderDto[]): Observable<EpimsGenderDto[]> {
    return this.http.post<EpimsGenderDto[]>(this.url + 'gender', data);
  }
  getSingleGender(id: string): Observable<any> {
    return this.http.get(this.url + 'gender/' + id);
  }

  updateGender(data: EpimsGenderDto[]): Observable<EpimsGenderDto[]> {
    return this.http.post<EpimsGenderDto[]>(this.url + 'gender/update', data);
  }

  deleteGender(ids: any) {
    const httpOptions = {
      headers: new HttpHeaders({ 'Content-Type': 'application/json' }),
      body: ids,
    };

    let params = new HttpParams();
    params = params.append('gender', ids.join(', '));
    return this.http.delete(this.url + 'gender', httpOptions);
  }
}
